<app-navigation></app-navigation>
<router-outlet></router-outlet>
<app-footer></app-footer>
<!-- Whatsapp -->
<a  target="_blank" href="https://wa.me/6282392590880?text=Hi, ada yang dapat kami bantu?">
    <div class="fixed bottom-9 right-9 z-50 flex h-16 w-16 items-center justify-center rounded-full bg-green-400 text-white hover:bg-green-600">
        <span><fa-icon class="text-5xl text-white" [icon]="faWhatsapp"></fa-icon></span>
    </div>
</a>